import { ThemeProvider, useTheme } from '@mui/material/styles';
import { type JSX, type ReactNode, useMemo } from 'react';
import { type DesignSystemComponentKey, scopeDesignSystem } from './scopeDesignSystem.ts';

type DesignSystemScopeProps = {
  /** Pass a module-level constant: a new array on every render rebuilds the theme. */
  keys: readonly DesignSystemComponentKey[];
  children: ReactNode;
};

// Outer theme via `useTheme`: a function `theme` prop crashes without a root ThemeProvider.
export const DesignSystemScope = ({ keys, children }: DesignSystemScopeProps): JSX.Element => {
  const outer = useTheme();
  const theme = useMemo(() => scopeDesignSystem(keys)(outer), [keys, outer]);

  return <ThemeProvider theme={theme}>{children}</ThemeProvider>;
};
